export default (state) => state.restricted.contact.current_conversation;
